import styled from '@emotion/styled';
import SubHeading from './SubHeading';

const SubHeadingWithIcon = styled(SubHeading)({
  paddingLeft: '16px',
  position: 'relative',
});

export default SubHeadingWithIcon;
